// extracted by mini-css-extract-plugin
module.exports = {"inner":"Footer_inner__1oRzQ","col":"Footer_col__1cOwe","copyright":"Footer_copyright__Ho2bi","socials":"Footer_socials__2ONQI","socialsMobile":"Footer_socialsMobile__1nR-t"};